var breakpoints_default = {
  sm: 600,
  md: 1024,
  lg: 1280,
  xl: 1441
};
const legacyBreakpoints = {
  s: 320,
  m: 768,
  l: 1024,
  xl: 1440
};
export {
  breakpoints_default as default,
  legacyBreakpoints
};
